import { Entry } from '../Entry'

export function Entry20220714() {
  return (
    <Entry title="14/07/2022 - v3.1.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12699/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
